import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SearchableSelect from './SearchableSelect';

function DepartmentSelect({ value, onChange, required = false, placeholder = "Select Department" }) {
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await axios.get('/api/departments');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const handleQuickAdd = async (name) => {
    try {
      const response = await axios.post('/api/departments', {
        name: name,
        description: `${name} department`
      });
      await fetchDepartments();
      return { value: response.data.name, label: response.data.name };
    } catch (error) {
      console.error('Error adding department:', error);
      throw error;
    }
  };

  const options = departments.map(dept => ({
    value: dept.name,
    label: dept.name
  }));

  return (
    <SearchableSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      onQuickAdd={handleQuickAdd}
      addButtonText="Add Department"
    />
  );
}

export default DepartmentSelect;